import React, { useState } from 'react';
import { preFormatFilterObject } from '@nile/reports/src/modules/component/helper';
import { FormattedMessage } from 'react-intl';
import { onQuerySearch } from '@nile/reports/src/modules/EfficiencyReport/graphql/resolver';
import { COMMON_CONSTANTS, Loader, withErrorBoundary } from '@nile/components';
import { cloneDeep, isEmpty } from 'lodash';
import { useQuery } from '@nile/graphql';
import { changeTimeFormat } from '@nile/reports/src/modules/EfficiencyReport/util';
import { DisplayText, TextStyle } from '@superops/ui-design-system';

const NumberMetaCard = ({ advancedChart, condition }) => {
  const { subHeader, labelKey, api } = advancedChart;

  const { client, query } = onQuerySearch(api);

  const [data, setData] = useState({});

  const { operands, reportCondition } = preFormatFilterObject({
    entity: 'ClientResourceEfficiency',
    filterObj: cloneDeep(condition),
    removeLabel: true
  });

  const { loading } = useQuery(query, {
    client,
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NETWORK_ONLY,
    variables: {
      input:
        (reportCondition &&
          !isEmpty(operands) && {
            joinOperator: 'AND',
            operands: operands || null
          }) ||
        null
    },
    onCompleted(res) {
      setData(res[api]);
    }
  });

  const getValue = (val) => {
    if (!val) return <FormattedMessage id="app.noData.message" />;
    const { days, hours, minutes } = changeTimeFormat(val);
    return `${(days && `${days}d`) || ''} ${(hours && `${hours}h`) ||
      ''} ${(minutes && `${minutes}m`) || ''}`;
  };

  return (
    <div className="flex fcol">
      <div className="flex">
        {!isEmpty(subHeader) && (
          <DisplayText element="h3" weight="SemiBold">
            <FormattedMessage id={subHeader} />
          </DisplayText>
        )}
      </div>
      <div className="flex g20">
        {Object.entries(labelKey)?.map(([key, value]) => (
          <div className="flex fcol mt10 w250">
            <div className="flex mb10">
              <TextStyle>
                <FormattedMessage id={value} />
              </TextStyle>
            </div>
            <div className="flex">
              {loading ? (
                <Loader />
              ) : (
                <>
                  {(!isEmpty(data) && (
                    <DisplayText element="h2" weight="SemiBold">
                      {getValue(data?.[key])}
                    </DisplayText>
                  )) || (
                    <TextStyle variation="subdued" weight="SemiBold">
                      <FormattedMessage id="app.noData.message" />
                    </TextStyle>
                  )}
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default withErrorBoundary(NumberMetaCard);
